function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import React, { PureComponent } from 'react';
import { scrollbarSize } from '../utils';
var styles = {
  "root": "Cal__Weekdays__root",
  "day": "Cal__Weekdays__day"
};

var Weekdays = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Weekdays, _PureComponent);

  function Weekdays() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Weekdays.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        weekdays = _this$props.weekdays,
        weekStartsOn = _this$props.weekStartsOn,
        theme = _this$props.theme;
    var orderedWeekdays = [].concat(weekdays.slice(weekStartsOn, 7), weekdays.slice(0, weekStartsOn));
    return /*#__PURE__*/React.createElement("ul", {
      className: styles.root,
      style: {
        backgroundColor: theme.weekdayColor,
        color: theme.textColor.active,
        paddingRight: scrollbarSize
      },
      "aria-hidden": true
    }, orderedWeekdays.map(function (val, index) {
      return /*#__PURE__*/React.createElement("li", {
        key: "Weekday-" + index,
        className: styles.day
      }, val);
    }));
  };

  return Weekdays;
}(PureComponent);

export { Weekdays as default };